import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { FinanceLeadsRowComponent } from "./finance-leads-row/finance-leads-row.component";
import { LeadFinanceService } from "../../@core/api/leadFinance.service";
import { NbWindowService, NbWindowState } from "@nebular/theme";
import { LenguageService } from "../../@core/utils/lenguage.service";
import { Router } from "@angular/router";
import { LeadFinance } from "../../@core/data/leadFinance";

@Component({
  selector: "ngx-finance-leads-table",
  templateUrl: "./finance-leads-table.component.html",
  styleUrls: ["./finance-leads-table.component.scss"],
})
export class FinanceLeadsTableComponent implements OnInit {
  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  leads: LeadFinance[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 100,
    pageNumber: 0,
  };
  order = {
    field: "timestamp",
    direction: "desc",
  };
  range: any;
  selectedRowId: string = "";
  addFilter: boolean = false;
  dateRange: {
    dateStart: number;
    dateEnd: number;
  };

  constructor(
    private windowService: NbWindowService,
    private router: Router,
    private leadService: LeadFinanceService,
    public language: LenguageService
  ) {}

  async ngOnInit() {
    this.getLeadsFinance();
  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getLeadsFinance();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getLeadsFinance();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads; */
  }

  async getLeadsFinance() {
    this.loading = true;
    this.leads = <LeadFinance[]>(
      await this.leadService.getLeadsFinance(
        this.pagination,
        this.filters,
        this.order
      )
    );
    this.loading = false;

    if (this.leads.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }
  }

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = (new Date(this.range.start).getTime() * 1000) / 1000;
    this.filters.dateRange = { dateStart, dateEnd };
  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getLeadsFinance();
  }
}
